import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
  showNavbar?: boolean;
}
const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  title = "",
  showNavbar = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        background: "var(--dashboard-page-bg)",
        alignItems: "stretch",
      }}
    >
      <Sidebar />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          background: "var(--dashboard-page-bg)",
        }}
      >
        {showNavbar && <Navbar title={title} />}

        <Box
          sx={{
            flex: 1,
            minHeight: "calc(100vh - 72px)",
            padding: "12px 24px",
            background: "var(--dashboard-page-bg)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
              pb: { xs: 2, md: 3 },
              mb: { xs: 1, md: 1.5 },
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
